module.exports = __webpack_public_path__ + "static/img/5.1bb69eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Accidentes-personales/5.png
// module id = Heko
// module chunks = 0